import { getLocaleStore } from '@/i18n/index';
import { getSysType, SYSTEM_TYPE } from '@/utils/platform-kit';

export enum HOTKEY_TYPE {
    /** 撤销 */
    undo = 'undo',
    /** 重做 */
    redo = 'redo',
    /** 删除 */
    delete = 'delete',
    /** 剪切 */
    cut = 'cut',
    /** 复制 */
    copy = 'copy',
    /** 粘贴 */
    paste = 'paste',
    /** 创建副本 */
    createCopy = 'createCopy',
    /** 固定位置粘贴 */
    fixedPaste = 'fixedPaste',
    /** 左移 */
    left = 'left',
    /** 右移 */
    right = 'right',
    /** 上移 */
    up = 'up',
    /** 下移 */
    down = 'down',
    /** 快速上移 */
    quickUp = 'quickUp',
    /** 快速下移 */
    quickDown = 'quickDown',
    /** 快速左移 */
    quickLeft = 'quickLeft',
    /** 快速右移 */
    quickRight = 'quickRight',
    /** 成组 */
    makeGroup = 'makeGroup',
    /** 解组 */
    brokeGroup = 'brokeGroup',
    /** 全选 */
    selectAll = 'selectAll',
    /** 多选 */
    select = 'select',
    /** 锁定图层 */
    lock = 'lock',
    /** 上移一层 */
    sortUp = 'sortUp',
    /** 下移一层 */
    sortDown = 'sortDown',
    /** 置底 */
    sortTop = 'sortTop',
    /** 置顶 */
    sortBottom = 'sortBottom',
    /** 保存 */
    save = 'save',
    /** 保存记录 */
    saveRecord = 'saveRecord',
    /** 移动 */
    move = 'move',
    /** 快速移动 */
    quickMove = 'quickMove',
    /** 舞台缩放 */
    scale = 'scale',
    /** 退出全屏 */
    esc = 'esc',
    /** 新建文字 */
    T = 'T',
    /** 新建矩形 */
    R = 'R',
    /** 新建圆形 */
    O = 'O',
    /** 新增直线 */
    L = 'L',
    /** 显示、隐藏参考线 */
    toggleReferenceLine = 'toggleReferenceLine',
    /** 显示、隐藏标尺 */
    toggleRulerBar = 'toggleRulerBar',
}

export const hotkeyConfigArr = () => {
    const { $t } = getLocaleStore();

    return [
        {
            key: HOTKEY_TYPE.undo,
            name: $t((v) => v.keyboardKeyMap.undo),
            win: 'Ctrl + Z',
            mac: '⌘ + Z',
            press: ['Ctrl+Z', 'Command+Z'],
            winMenu: 'Ctrl Z',
            macMenu: '⌘ Z',
        },
        {
            key: HOTKEY_TYPE.redo,
            name: $t((v) => v.keyboardKeyMap.redo),
            win: 'Shift + Ctrl + Z',
            mac: '⇧ + ⌘ + Z',
            press: ['Shift+Ctrl+Z', 'Shift+Command+Z', 'Ctrl+y', 'Command+y'],
            winMenu: 'Shift Ctrl Z',
            macMenu: '⇧ ⌘ Z',
        },
        {
            name: $t((v) => v.keyboardKeyMap.delete),
            win: 'Delete/Backspace',
            mac: 'Delete',
            key: HOTKEY_TYPE.delete,
            press: ['Delete', 'Backspace'],
            winMenu: 'Del',
            macMenu: 'Del',
        },
        {
            name: $t((v) => v.keyboardKeyMap.cut),
            win: 'Ctrl + X',
            mac: '⌘ + X',
            key: HOTKEY_TYPE.cut,
            press: ['Ctrl+X', 'Command+X'],
            winMenu: 'Ctrl X',
            macMenu: '⌘ X',
        },
        {
            name: $t((v) => v.keyboardKeyMap.copy),
            win: 'Ctrl + C',
            mac: '⌘ + C',
            key: HOTKEY_TYPE.copy,
            press: [],
            winMenu: 'Ctrl C',
            macMenu: '⌘ C',
        },
        {
            name: $t((v) => v.keyboardKeyMap.paste),
            win: 'Ctrl + V',
            mac: '⌘ + V',
            key: HOTKEY_TYPE.paste,
            press: [],
            winMenu: 'Ctrl V',
            macMenu: '⌘ V',
        },
        {
            name: $t((v) => v.keyboardKeyMap.fixedPaste),
            win: 'Ctrl + Shift + V',
            mac: '⌘ + ⇧ + V',
            key: HOTKEY_TYPE.fixedPaste,
            press: ['Ctrl+Shift+V', 'Command+Shift+V'],
            winMenu: 'Ctrl Shift V',
            macMenu: '⌘ ⇧ V',
        },
        {
            name: $t((v) => v.keyboardKeyMap.createCopy),
            win: 'Ctrl + D',
            mac: '⌘ + D',
            key: HOTKEY_TYPE.createCopy,
            press: ['Ctrl+D', 'Command+D'],
            winMenu: 'Ctrl D',
            macMenu: '⌘ D',
        },
        {
            name: $t((v) => v.keyboardKeyMap.selectAll),
            win: 'Ctrl + A',
            mac: '⌘ + A',
            key: HOTKEY_TYPE.selectAll,
            press: ['Ctrl+A', 'Command+A'],
            winMenu: 'Ctrl A',
            macMenu: '⌘ A',
        },
        {
            name: $t((v) => v.keyboardKeyMap.multipleSelect),
            win: $t((v) => v.keyboardKeyMap.multipleSelectDescWin),
            mac: $t((v) => v.keyboardKeyMap.multipleSelectDescMac),
            key: HOTKEY_TYPE.select,
            press: [],
            winMenu: 'Ctrl/Alt',
            macMenu: '⌘/⌥',
        },
        {
            name: $t((v) => v.keyboardKeyMap.makeGroup),
            win: 'Ctrl + G',
            mac: '⌘ + G',
            key: HOTKEY_TYPE.makeGroup,
            press: ['Ctrl+G', 'Command+G'],
            winMenu: 'Ctrl G',
            macMenu: '⌘ G',
        },
        {
            name: $t((v) => v.keyboardKeyMap.brokeGroup),
            win: 'Shift + Ctrl + G',
            mac: '⇧ + ⌘ + G',
            key: HOTKEY_TYPE.brokeGroup,
            press: ['Ctrl+Shift+G', 'Command+Shift+G'],
            winMenu: 'Shift Ctrl G',
            macMenu: '⇧ ⌘ G',
        },
        {
            name: $t((v) => v.keyboardKeyMap.lock),
            win: 'Shift + Ctrl + L',
            mac: '⇧ + ⌘ + L',
            key: HOTKEY_TYPE.lock,
            press: ['Command+Shift+L', 'Shift+Ctrl+L'],
            winMenu: 'Shift Ctrl L',
            macMenu: '⇧ ⌘ L',
        },
        {
            name: $t((v) => v.keyboardKeyMap.saveRecord),
            win: 'Ctrl + S',
            mac: '⌘ + S',
            key: HOTKEY_TYPE.save,
            press: ['Ctrl+S', 'Command+S'],
            winMenu: 'Ctrl S',
            macMenu: '⌘ S',
        },
        {
            name: $t((v) => v.keyboardKeyMap.move),
            win: $t((v) => v.keyboardKeyMap.ArrowKey),
            mac: $t((v) => v.keyboardKeyMap.ArrowKey),
            key: HOTKEY_TYPE.move,
            press: ['Up', 'Right', 'Down', 'Left'],
            winMenu: $t((v) => v.keyboardKeyMap.ArrowKey),
            macMenu: $t((v) => v.keyboardKeyMap.ArrowKey),
        },
        {
            name: $t((v) => v.keyboardKeyMap.move),
            win: $t((v) => v.keyboardKeyMap.ArrowKey),
            mac: $t((v) => v.keyboardKeyMap.ArrowKey),
            key: HOTKEY_TYPE.quickMove,
            press: [
                ['Ctrl+Up', 'Command+Up', 'Shift+Up'],
                ['Ctrl+Right', 'Command+Right', 'Shift+Right'],
                ['Ctrl+Down', 'Command+Down', 'Shift+Down'],
                ['Ctrl+Left', 'Command+Left', 'Shift+Left'],
            ],
            winMenu: $t((v) => v.keyboardKeyMap.ArrowKey),
            macMenu: $t((v) => v.keyboardKeyMap.ArrowKey),
        },
        {
            name: $t((v) => v.keyboardKeyMap.scale),
            win: 'Ctrl + +/-',
            mac: '⌘ + +/-',
            key: HOTKEY_TYPE.scale,
            press: [
                ['Ctrl++', 'Command++', 'Ctrl+=', 'Command+='],
                ['Ctrl+-', 'Command+-', 'Ctrl+_', 'Command+_'],
            ],

            winMenu: $t((v) => v.keyboardKeyMap.ArrowKey),
            macMenu: $t((v) => v.keyboardKeyMap.ArrowKey),

            // ignoreDisablePick: true,
        },

        {
            name: $t((v) => v.keyboardKeyMap.sortTop),
            win: 'Shift + Ctrl + ↑',
            mac: '⇧ + ⌘ + ↑',
            key: HOTKEY_TYPE.sortTop,
            press: ['Shift+Ctrl+Up', 'Shift+Command+Up'],
            winMenu: 'Shift Ctrl ↑',
            macMenu: '⇧ ⌘ ↑',
        },
        {
            name: $t((v) => v.keyboardKeyMap.sortBottom),
            win: 'Shift + Ctrl + ↓',
            mac: '⇧ + ⌘ + ↓',
            key: HOTKEY_TYPE.sortBottom,
            press: ['Shift+Ctrl+Down', 'Shift+Command+Down'],
            winMenu: 'Shift Ctrl ↓',
            macMenu: '⇧ ⌘ ↓',
        },
        {
            name: $t((v) => v.keyboardKeyMap.sortUp),
            win: 'Alt + Ctrl + ↑',
            mac: '⌥ + ⌘ + ↑',
            key: HOTKEY_TYPE.sortUp,
            press: ['Alt+Ctrl+Up', 'Option+Command+Up'],
            winMenu: 'Alt Ctrl ↑',
            macMenu: '⌥ ⌘ ↑',
        },
        {
            name: $t((v) => v.keyboardKeyMap.sortDown),
            win: 'Alt + Ctrl + ↓',
            mac: '⌥ + ⌘ + ↓',
            key: HOTKEY_TYPE.sortDown,
            press: ['Alt+Ctrl+Down', 'Option+Command+Down'],
            winMenu: 'Alt Ctrl ↓',
            macMenu: '⌥ ⌘ ↓',
        },
        {
            name: $t((v) => v.keyboardKeyMap.exitFullScreen),
            key: HOTKEY_TYPE.esc,
            win: $t((v) => v.keyboardKeyMap.esc),
            mac: $t((v) => v.keyboardKeyMap.esc),
            press: ['ESC'],
            winMenu: $t((v) => v.keyboardKeyMap.esc),
            macMenu: $t((v) => v.keyboardKeyMap.esc),

            ignoreDisablePick: true,
        },
        {
            name: $t((v) => v.keyboardKeyMap.createText),
            key: HOTKEY_TYPE.T,
            win: 'T',
            mac: 'T',
            press: ['T'],
            winMenu: 'T',
            macMenu: 'T',
        },
        {
            name: $t((v) => v.keyboardKeyMap.createLine),
            key: HOTKEY_TYPE.L,
            win: 'L',
            mac: 'L',
            press: ['L'],
            winMenu: 'L',
            macMenu: 'L',
        },
        {
            name: $t((v) => v.keyboardKeyMap.createRect),
            key: HOTKEY_TYPE.R,
            win: 'R',
            mac: 'R',
            press: ['R'],
            winMenu: 'R',
            macMenu: 'R',
        },
        {
            name: $t((v) => v.keyboardKeyMap.createCircle),
            key: HOTKEY_TYPE.O,
            win: 'O',
            mac: 'O',
            press: ['O'],
            winMenu: 'O',
            macMenu: 'O',
        },
        {
            name: $t((v) => v.keyboardKeyMap.toggleReferenceLine),
            win: 'Ctrl + ;',
            mac: '⌘ + ;',
            key: HOTKEY_TYPE.toggleReferenceLine,
            press: ['Ctrl+;', 'Command+;'],
            winMenu: 'Ctrl ;',
            macMenu: '⌘ ;',
        },
        {
            name: $t((v) => v.keyboardKeyMap.toggleRulerBar),
            win: 'Shift + r',
            mac: '⇧ + r',
            key: HOTKEY_TYPE.toggleRulerBar,
            press: ['Shift+r'],
            winMenu: 'Shift r',
            macMenu: '⇧ r',
        },
    ];
};

export const hotkeyConfigMap = {};
hotkeyConfigArr().forEach((item) => {
    hotkeyConfigMap[item.key] = item;
});

const system = getSysType();
const prefix = system === SYSTEM_TYPE.MAC ? 'mac' : 'win';

export const getHotkeyMenu = (key: HOTKEY_TYPE) => {
    return hotkeyConfigMap[key][prefix];
};

export default hotkeyConfigMap;
